module.exports = "/assets/pattern-rw-tile.png?W7F5Vjt";